// extracted by mini-css-extract-plugin
module.exports = {"draggable":"oaRSP","dragging":"DX+hZ"};